import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  sensorData='1';
  columnDefs;
  rowData;
  drilldowncolums;
  drilldownrows;
  siteId_sitename;
  returnSiteDetails
  equipmentTabID = '';
  equipmentTabName = '';
  message = '';
  analyticalAvailability;
  messageType = '';
  ossmessage = '';
  ossmessageType = '';
  finalarr: any[] = [];
  stDate = '';
  endDate = '';
  reportType = '';
  timeType = '';
  sid = '';
  allSensorType = 'line';
  hourDate = '';
  selectedWeek = '';
  selectedMonth = '';
  selectedQuarter = '';
  selectedYear = '';
  selectedRegion = '';
  selectedCluster = '';
  selectedSiteClass = '';
  selectedCoolingClass = '';
  selectedEnergyClass = '';
  selectedReportCategory = '';
  chartxparam: any[] = [];
  selectedMeterID = '';
  searchSiteId = '';
  regionName = [];
  clusterName = [];
  selectedReportTypeName = '';
  sid_Name = '';
  selectWeek;
  energyReport;
  analyticalReport;
  controllerReport;
  customReport;
  customFromDate
  customToDate
  detailedReport = [
    { "id": "1", "name": "DC Energy Consumption" },
    { "id": "2", "name": "AC Energy Consumption" },
    { "id": "3", "name": "Fuel Consumption + DG Run Hours" },
    { "id": "4", "name": "Alarm Count" },
    { "id": "5", "name": "Alarm Detail" },
    { "id": "6", "name": "Site Status" },
    { "id": "7", "name": "Battery Backup" },
    { "id": "8", "name": "Generator Run Hours" },
    { "id": "9", "name": "Battery Controller Report" },
    { "id": "10", "name": "BMS Report" },

  ];
  summaryReport = [
    { "id": "1", "name": "DC Energy Consumption" },
    { "id": "2", "name": "AC Energy Consumption" },
    { "id": "3", "name": "Fuel Consumption + DG Run Hours" },
    { "id": "4", "name": "Site Status Summary" },
    { "id": "5", "name": "Energy Model" },
    { "id": "6", "name": "Battery Backup" },
    { "id": "7", "name": "Generator Run Hours" }
  ];

  additionalFields = [
    { 'id': '1', 'fieldName': 'AC Power', 'fieldId': 'acelPower' },
    { 'id': '2', 'fieldName': 'DC Power', 'fieldId': 'dcenlPower' },
    { 'id': '3', 'fieldName': 'SOC %', 'fieldId': 'rclbatterycapacity' },
    { 'id': '4', 'fieldName': 'Temperature', 'fieldId': 'diolShelterTemp' },
    { 'id': '5', 'fieldName': 'DCVolt', 'fieldId': 'dcenlDCPPVolt' },
    { 'id': '6', 'fieldName': 'FuelLevel', 'fieldId': 'fdlfuelLevel' },
  ]
  additionalFields_site = [
    { 'id': '1', 'fieldName': 'AC Power', 'fieldId': 'acelPower' },
    { 'id': '2', 'fieldName': 'DC Power', 'fieldId': 'dcenlPower' },
    { 'id': '3', 'fieldName': 'SOC %', 'fieldId': 'rclbatterycapacity' },
    { 'id': '4', 'fieldName': 'DCVolt', 'fieldId': 'dcenlDCPPVolt' },
    { 'id': '5', 'fieldName': 'FuelLevel', 'fieldId': 'fdlfuelLevel' },
    { 'id': '6', 'fieldName': 'Shelter Temperature', 'fieldId': 'diolShelterTemp' },
    { 'id': '7', 'fieldName': 'Ambient Temperature', 'fieldId': 'diolAmbientTemp' },

  ]


}